import { Component, computed, input, output } from '@angular/core';
import { ButtonComponent } from '../button/button.component';
import { type CalloutType } from './callout.model';

@Component({
  selector: 'lib-callout',
  imports: [ButtonComponent],
  styleUrls: [
    '../../tokens/colors.css',
    '../../tokens/callout-tokens.css',
    './callout.component.css',
  ],
  templateUrl: './callout.component.html',
  host: {
    '[class]': 'hostClasses()',
    'role': 'alert',
  },
})
export class CalloutComponent {
  /** Bold title prefix (e.g. "Consejo:", "Atención:"). */
  title = input<string>();

  /** Message text. */
  message = input.required<string>();

  /** Visual type drives color scheme. */
  type = input<CalloutType>('info');

  /** Shows close button when true. */
  dismissible = input<boolean>(false);

  /** Emits when the close button is clicked. */
  dismissed = output<void>();

  readonly hostClasses = computed(() => {
    const type = this.type();
    return {
      'msa-callout': true,
      [`msa-callout--${type}`]: true,
    };
  });

  onDismiss(): void {
    this.dismissed.emit();
  }
}
